import React from 'react';
import {
    Route as ReactDOMRoute,
    Redirect,
} from 'react-router-dom';

import { useAuth } from '../hooks/auth';

import Authorized from '../pages/Layouts/Authorized';
import NotAuthorized from '../pages/Layouts/NotAuthorized';

const Route = ({ isPrivate = false, component: Component, allowedRoles, ...rest }) => {
    const { user, userRoles } = useAuth();

    if (user) {
        if (allowedRoles != null && !allowedRoles.some(role => userRoles?.includes(role))) {
            return <Redirect to="/" />;
        }
    }

    if (!user && isPrivate) {
        return <Redirect to="/signin" />;
    }

    const Layout = user ? Authorized : NotAuthorized;

    return (
        <ReactDOMRoute isPrivate={isPrivate} {...rest}>
            <Layout>
                <Component />
            </Layout>
        </ReactDOMRoute>
    );
};

export default Route;
